import React from 'react'

import { Box } from '~/components/elements/Box'

import styles from './SelectorListContainer.css'

export type SelectorListContainerProps = React.PropsWithChildren<{
  'data-testid'?: string
}>

export const SelectorListContainer = ({
  children,
  'data-testid': dataTestId = 'components-features-selector-list-container',
}: SelectorListContainerProps) => (
  <Box
    backgroundColor="transparent"
    className={styles.root}
    data-testid={dataTestId}
  >
    {children}
  </Box>
)
